import { createSelector } from 'reselect'

import { findPostPurchaseCheckout } from 'lib/checkout/checkoutUtils'

type FlightSeatsState = NonNullable<App.CheckoutState['flightSeats']>

/**
 * What the customer pays for a post-booking seat change.
 *
 * Same-price and dearer seats are charged at full list price, not the difference from the held
 * seat. Cheaper seats are charged at $0 — there is no refund of what was already paid. See
 * `paidSeatPricesForReservation` in svc-flights for where that charge is resolved.
 */
export function getFlightSeatsTotalPrice(flightSeats: FlightSeatsState): number {
  return flightSeats.selections.reduce((total, selection) => total + selection.price, 0)
}

export const getFlightSeatsTotal = createSelector(
  (state: App.State) => findPostPurchaseCheckout(state.checkout.cart.mode),
  (state: App.State) => state.checkout.flightSeats,
  (postPurchaseMode, flightSeats): number => {
    if (postPurchaseMode !== 'flight-seats' || !flightSeats) { return 0 }
    return getFlightSeatsTotalPrice(flightSeats)
  },
)

export function buildFlightSeatAddonInputs(
  flightSeats: FlightSeatsState,
): Array<App.FlightSeatAddonInput> {
  return flightSeats.selections.map((selection) => ({
    type: 'SEATS',
    payload: {
      travellerId: selection.travellerId,
      flightId: selection.flightId,
      seatNumber: selection.seatNumber,
    },
  }))
}
